import {UseToast} from "../hooks/useToast";
import {AdvancePaymentResponse, AnnulPenaltyInvoice, CreateAdvancePaymentRequest} from "../types/types";
import axios, {AxiosResponse} from "axios";
import advancePayments from "../../components/invoices/advancePayments/AdvancePayments";

export class AdvancePaymentService {
    private readonly url: string;
    private readonly toastHelpers: Pick<UseToast, 'showDeletedToast' | 'showUpdatedToast' | 'showCreatedToast' | 'showToast'>
    private readonly f: any;

    constructor(f: any, toastHelpers: Pick<UseToast, 'showDeletedToast' | 'showUpdatedToast' | 'showCreatedToast' | 'showToast'>) {
        this.toastHelpers = toastHelpers;
        this.f = f;
        this.url = '/advance-payments';
    }

    async createAdvancePayment(advancePayment: CreateAdvancePaymentRequest) {
        return new Promise<AdvancePaymentResponse>((resolve, reject) => {
            axios.post<AdvancePaymentResponse>(`${this.url}`, advancePayment).then(response => {
                if(response.data){
                    this.toastHelpers.showToast("success", this.f({id: 'operationSuccessful'}), ``, false);
                    resolve(response.data)
                }
            }).catch(err => {
                this.toastHelpers.showToast("error", this.f({id: 'operationUnsuccessful'}), '', false);
                reject(err);
            });
        })
    }

    async downloadAdvancePaymentInvoice(advancePaymentInvoiceId: number) {
        return new Promise<any>((resolve, reject) => {
            axios.post(`${this.url}/${advancePaymentInvoiceId}`, {}, {responseType: 'arraybuffer'}).then(response => {
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'],
                });
                resolve(blob);
            }).catch(reject);
        })
    }

    async createCreditNotice(advancePaymentInvoiceId: number, note?: string, date?: Date | undefined | null) {
        return new Promise<any>((resolve, reject) => {
            axios.post(`${this.url}/${advancePaymentInvoiceId}/credit-notice`, {note, date}, {responseType: 'arraybuffer'})
                .then(resp => {
                    if (resp.data) {
                        resolve(resp.data);
                        this.toastHelpers.showToast("success", this.f({id: 'operationSuccessful'}), `${this.f({id: 'invoice'})} ${resp.data}`, false);
                    } else {
                        reject(false);
                        this.toastHelpers.showToast("error", this.f({id: 'operationUnsuccessful'}), '', false);
                    }
                }).catch(err => {
                reject(err);
                this.toastHelpers.showToast("error", this.f({id: 'operationUnsuccessful'}), '', false);
            })
        })
    }

    async exportExcel(filters: Record<string, string>) {
        return new Promise<AxiosResponse<BlobPart>>((resolve, reject) => {
            axios.post<BlobPart>(this.url + "/excel", filters, {responseType: 'arraybuffer'}).then(response => {
                resolve(response)
            }).catch(err => reject(err))
        })
    }

    async deletePenaltyInvoiceFile(deletePenaltyInvoiceFileModel: AnnulPenaltyInvoice) {
        return new Promise<boolean>((resolve, reject) => {
            axios.post<boolean>(`${this.url}/annul`, deletePenaltyInvoiceFileModel).then(resp => {
                this.toastHelpers.showToast('success', this.f({id: 'operationSuccessful'}), "");
                resolve(true);
            }).catch(reject)
        })
    }

}
